<template>
  <div class="productList">
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <!-- <div class="page-width">
      <div class="sonNav">
        <swiper class="hidden-md-and-up" :options="recommendedSwiper" ref="mySwiper">
          <swiper-slide v-for="(item,index) in sonNavList" data-index="index" :key="index">
            <a :href="item.id" style="max-width: 136px">{{item.name}}</a>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev el-icon-caret-left hidden-md-and-up"></div>
        <div class="swiper-button-next el-icon-caret-right hidden-md-and-up"></div>
        <ul class="hidden-md-and-down">
          <li v-for="(item,index) in sonNavList" data-index="index" :key="index" @click="fetchSelectedCategories(item.ProductCategory_id)">
            <a >{{item.Name}}</a>
          </li>
        </ul>
      </div>
    </div> -->
        <div class="search-box">
        <!-- <el-input placeholder="Search" v-model="input2" >
          <template slot="append" style="background-color: #ff6f37" class="search_submit">Submit</template>
        </el-input> -->
          <input type="text" v-bind:placeholder="$t('productNameOrNumber')"  v-model="searchTerm" v-on:keyup.enter="searchProduct">
          <button @click="searchProduct" >{{ $t('submit') }}</button>
      </div>
    <!--end search form-->
    <div class="product-listing-container search-product-list-container">
      <div class="page-width">
        <ul>
          <li v-for="(item,index) in list" data-index="index" :key="index">
            <productCard v-if='$i18n.locale=="en"'
              v-bind:img="item.Thumbnail"
              v-bind:link="item.link"
              v-bind:name="item.Name"
              v-bind:isPromotion="item.IsPromotion"
              v-bind:price="item.Price"
              v-bind:item="item"
              v-bind:quantity="item.Quantity"
              v-bind:key="index"
            ></productCard>
            <productCard v-if='$i18n.locale=="ch"'
              v-bind:img="item.Thumbnail"
              v-bind:link="item.link"
              v-bind:name="item.Description"
              v-bind:isPromotion="item.IsPromotion"
              v-bind:price="item.Price"
              v-bind:item="item"
              v-bind:quantity="item.Quantity"
              v-bind:key="index"
            ></productCard>
          </li>
        </ul>
        <!-- <div class="loadmore disableBtn" v-show="list.length === 0">
          <span>No Results</span>
          <i class="loading">
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
          </i>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import breadcrumb from "@/components/breadcrumb";
import productCard from './productCard';
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../store/modules/cart";

export default {
  name: "search",
  components: {
    breadcrumb,
    productCard
  },
  props: {
    group: {
      type: String,
    }
  },
  data() {
    return {
      collection:"",
      searchTerm: "",
      options: [{
        value: '选项1',
        label: 'Featured Items'
      }, {
        value: '选项2',
        label: 'Best Selling'
      }, {
        value: '选项3',
        label: 'Alphabetically, A-Z'
      }, {
        value: '选项4',
        label: 'Alphabetically, Z-A'
      }, {
        value: '选项5',
        label: 'Price, low to high'
      }],
      recommendedSwiper: {
        slidesPerView: 5,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        roundLengths : true,
        spaceBetween: 20,
        breakpoints: {
          320: {
            slidesPerView: 1,
          },
          //width >= 480
          480:{
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 4,
          },
          //width >= 640
          990: {
            slidesPerView: 4,
          },
          1200:{
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 5,
          }
        }
      },
      list: [],
      product: '',
      path2: this.$t('search'),
    }
  },
  methods: {
    ...mapActions('search',['fetchProducts']),
    ...mapMutations('products', ['updateActiveProduct']),
    isOutOfStock(item) {
      if(item.IsOverSaleable) {
        return false
      }
      return item.StockLevel > 0 ? false : true
    },
    searchProduct() {
      this.$router.push({ path: 'search', query: { product: this.searchTerm }})
    },
    isOutOfStockBusiness(item) {
      let master, inner, type;
      let b2bItems = {};
      let soldOut = false;
      // map through b2b items and check for proper casing. Add to hash map.
      if (item.MasterInner && item.MasterInner.length) {
        item.MasterInner.map(b2bCase => {
          if (b2bCase.ProductNum.charAt(item.MasterInner[0].ProductNum.length - 1) === "0" && !master) {
            master = true;
            b2bItems[master] = b2bCase
          }
          if (b2bCase.ProductNum.charAt(item.MasterInner[0].ProductNum.length - 1) === "2" && !inner) {
            inner = true;
            b2bItems[inner] = b2bCase
          }
        });
      }
      // if a master case and inner case exists, default to master case even if inner is not sold out (per AFG's request)
      if (master) {
        type = "master";
      } else {
        type = "inner";
      }
      // if master, check the master property and see if the master case quantity is greater than the single case stock level. 
      if (type === "master") {
        if (b2bItems[master] && b2bItems[master].ConvertNum > item.StockLevel) {
          soldOut = true
        }
        // else do the same for inner 
      } else {
        if (b2bItems[inner] && b2bItems[inner].ConvertNum > item.StockLevel) {
          soldOut = true;
        }
      }
      return soldOut;
    },
    fetchProductWithSearchTerm(product) {
      this.list = [];
      this.fetchProducts(product)
      .then(res => {
        let ctemp1 = [];
        let ctemp2 = [];
        let catOut = [];
        let catReg = [];
        res.data.Products.map((a)=>{
          if (this.userDetails && this.userDetails.IsBusiness) {
            if (this.isOutOfStockBusiness(a)) {
              ctemp2.push(a)
            } else {
              ctemp1.push(a)
            }
          } else {
            if (this.isOutOfStock(a)) {
              ctemp2.push(a)
            } else {
              ctemp1.push(a)
            }
          }
         })
        catOut = ctemp2.sort((a,b)=>{
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        });
        catReg = ctemp1.sort((a,b) => {
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        })
        this.list = catReg.concat(catOut);

        this.searchTerm = '';
      })
      .catch(err => {
        console.log('err fetching product', err)
      })
    },
    addToCart: function(item) {
      item.quantity = this.num;
      if (isUserAuthenticated()) {
        item.quantity = this.num;
        this.$store.dispatch('cart/addCart', item);
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item);
      }
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({ name: 'productDetails', query: { productNum: product.ProductNum} })
    },
  },
  computed: mapState({
    search: state => state.navbar.search,
    activeProduct: state => state.products.activeProduct,
    product: state => state.products.productDetails[0],
    userDetails: state => state.auth.userDetails,
    business: state => state.auth.userDetails.IsBusiness,
  }),
  watch: {
    search: function(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.searchTerm = newVal;
        this.searchProduct();
      }
    },
    '$route.query': {
      immediate: true,
      handler(newVal) {
        this.fetchProductWithSearchTerm(newVal.product);
        this.product = newVal.product
      }
    },
    'userDetails.IsBusiness': {
      handler: function(newVal, oldVal) {
        this.showPrice = newVal;
        this.fetchProductWithSearchTerm(this.product);
      deep: true
      }
    },
  },
  mounted: function() {
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/productList.less";
@import "../assets/css/search.less";
</style>



// WEBPACK FOOTER //
// src/view/search.vue